import { z } from 'zod';

/** UUID v4/v7 string */
export const uuidSchema = z.string().uuid();

/** ISO 8601 date-time string */
export const isoDateTimeSchema = z.string().datetime({ offset: true });

/** Date only: YYYY-MM-DD (legacy task dueDate format) */
export const dateOnlySchema = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, 'Дата должна быть в формате YYYY-MM-DD');

/** Local wall-clock time HH:MM (no timezone column). */
export const timeOfDaySchema = z
  .string()
  .regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'Время должно быть в формате HH:MM');

/** Common pagination query */
export const paginationSchema = z.object({
  page: z.coerce.number().int().positive().default(1),
  pageSize: z.coerce.number().int().positive().max(100).default(50),
});
export type Pagination = z.infer<typeof paginationSchema>;

/** Standard API error response */
export const errorResponseSchema = z.object({
  error: z.string(),
  message: z.string().optional(),
  details: z.unknown().optional(),
});
export type ErrorResponse = z.infer<typeof errorResponseSchema>;
